module.exports = __webpack_public_path__ + "img/TZS09607.99a59209.jpeg";